export default __webpack_public_path__ + "static/media/complementary--roundabout-go-straight--g1.8374e8e8.png";